import { render, staticRenderFns } from "./ModalConfirmarGuardar.vue?vue&type=template&id=792ca7d7&scoped=true"
import script from "./ModalConfirmarGuardar.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarGuardar.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarGuardar.vue?vue&type=style&index=0&id=792ca7d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792ca7d7",
  null
  
)

export default component.exports